<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <!--   Main Content Start Here   -->
    <main>
      <section class="dashboard_wraper">
        <div class="container_large">
          <div class="row">
            <!-- starting side bar -->
            <sidebar-component></sidebar-component>
            <!-- ending sidebar  -->
            <div class="col-md-12 col-lg-9">
              <div class="dashboard_card">
                <div class="row">
                  <div class="col-6">
                    <h2>General Settings</h2>
                  </div>
                  <div class="col-6 text-right">
                    <router-link :to="{ name: 'admin-add-setting' }">
                      <button
                        type="button"
                        class="button primary_button"
                        aria-label="Close"
                      >
                        Add new
                      </button>
                    </router-link>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Key</th>
                        <th scope="col">Title</th>
                        <th scope="col">Value</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody v-if="settings && settings.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr v-for="data in settings" :key="data">
                        <td>{{ data.key }}</td>
                        <td>
                          {{ data.title }}
                        </td>
                        <td>{{ data.value }}</td>

                        <td>
                          <router-link
                            :to="{
                              name: 'admin-update-setting',
                              params: { id: data.id },
                            }"
                            class="table_action"
                            ><img src="/src/assets/images/edit-icon.svg" alt=""
                          /></router-link>
                        
                          <a
                            href="#"
                            class="table_action"
                            @click="deleteModal(data.id)"
                            ><img src="/src/assets/images/del-icon.svg" alt=""
                          /></a>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-if="!settings || !settings.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr>
                        You don't have created any order yet
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
import webSettingsApis from "../../Apis/webSettings";
import sidebarComponent from "./sidebar";
export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      settings: null,
    };
  },
  methods: {
    async getSettings() {
      this.settings = (await webSettingsApis.requestSettings("get", "")).data;
      this.loader = false;
    },
  },
  created() {
    this.getSettings();
    // setTimeout(() => {
    //   this.loader = false;
    // }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/generalSettings.vue